export interface PatronSpeaker {
  id: string;
  name: string;
  role: string;
  organization: string;
  imageSrc: string;
  category: 'guest_of_honor' | 'keynote_speaker' | 'industry_leader';
  bio?: string;
}

export const guestsOfHonor: PatronSpeaker[] = [
  {
    id: 'dattatray-bharne',
    name: 'Shri Dattatray Vithoba Bharne',
    role: "Hon'ble Minister for Agriculture",
    organization: 'Government of Maharashtra',
    imageSrc: 'https://iiabexpo.com/uploads/speakers/shri-dattatray-vithoba-bharne--1784360124.webp',
    category: 'guest_of_honor',
    bio: 'Leading agricultural policymaker championing modern farm inputs, irrigation enhancements, and sustainable farmer welfare initiatives across Maharashtra.',
  },
  {
    id: 'dr-pk-singh',
    name: 'Dr. PK Singh',
    role: 'Agriculture Commissioner',
    organization: 'Ministry of Agriculture & Farmers Welfare, Government of India',
    imageSrc: 'https://iiabexpo.com/uploads/speakers/dr-pk-singh-1784360353.webp',
    category: 'guest_of_honor',
    bio: 'Guiding national policy frameworks for crop production, chemical inputs standardization, and modern agricultural technology adoption across India.',
  },
  {
    id: 'mark-birrell',
    name: 'Mark Birrell',
    role: 'Trade Counsellor, South Asia',
    organization: 'UK Government (Department for Business and Trade)',
    imageSrc: 'https://iiabexpo.com/uploads/speakers/mark-birrell-1784360954.webp',
    category: 'guest_of_honor',
    bio: 'Spearheading bilateral agricultural trade linkages, British AgriTech partnerships, and strategic investment corridors between the UK and South Asia.',
  },
  {
    id: 'maa-chaitanya-meera',
    name: 'Maa Chaitanya Meera',
    role: 'Spiritual Head & Mentor',
    organization: 'Nirvana Ashram, Nashik',
    imageSrc: 'https://iiabexpo.com/uploads/speakers/maa-chaitanya-meera-1784360733.webp',
    category: 'guest_of_honor',
    bio: 'Guiding ethical stewardship, sustainable living, and ecological harmony in Indian agriculture and rural enterprise.',
  },
];

export const industrySpeakers: PatronSpeaker[] = [
  {
    id: 'ankur-aggarwal',
    name: 'Ankur Aggarwal',
    role: 'Executive Chairman & Managing Director',
    organization: 'Crystal Crop Protection Ltd',
    imageSrc: 'https://iiabexpo.com/uploads/speakers/ankur-aggarwal-1782132907.jpg',
    category: 'industry_leader',
    bio: 'Pioneering crop care innovation, formulation manufacturing, and indigenous ag-input research scale across India.',
  },
  {
    id: 'dr-rahul-mirchandani',
    name: 'Dr. Rahul Mirchandani',
    role: 'Chairman & Managing Director',
    organization: 'Aries Agro Ltd',
    imageSrc: 'https://iiabexpo.com/uploads/speakers/rahul-mirchandani-1782713733.jpg',
    category: 'industry_leader',
    bio: 'Trailblazer in chelated micronutrients, plant nutritional efficiency, and global specialty agribusiness exports.',
  },
  {
    id: 'rajvir-singh-rathi',
    name: 'Rajvir Singh Rathi',
    role: 'Vice President & Head of Public Affairs, Science & Sustainability',
    organization: 'Bayer CropScience',
    imageSrc: 'https://iiabexpo.com/uploads/speakers/rajvir-singh-rathi-1782713581.jpg',
    category: 'industry_leader',
    bio: 'Driving regulatory harmonisation, scientific policy dialogue, and regenerative agriculture programs across South Asia.',
  },
  {
    id: 'dr-krk-reddy',
    name: 'Dr. KRK Reddy',
    role: 'Managing Director',
    organization: 'Sri BioAesthetics Pvt Ltd',
    imageSrc: 'https://iiabexpo.com/uploads/speakers/krk-reddy-1747382318.png',
    category: 'industry_leader',
    bio: 'Eminent microbiologist and bio-stimulant pioneer developing next-generation microbial consortia and bio-efficacy tools.',
  },
  {
    id: 'prasad-chandran',
    name: 'Prasad Chandran',
    role: 'Former Chairman & Managing Director',
    organization: 'BASF India & South Asia',
    imageSrc: 'https://iiabexpo.com/uploads/speakers/prasad-chandran-1782372524.jpg',
    category: 'keynote_speaker',
    bio: 'Distinguished chemical industry veteran and governance thought leader with decades of executive leadership across multinational ag-chemistry.',
  },
  {
    id: 'abhijeet-bose',
    name: 'Abhijeet Bose',
    role: 'Executive President & Chief Operating Officer',
    organization: 'Tagros Chemicals India Pvt Ltd',
    imageSrc: 'https://iiabexpo.com/uploads/speakers/abhijeet-bose-1782713451.jpg',
    category: 'industry_leader',
    bio: 'Overseeing global synthetic pyrethroids production, active ingredient exports, and toll manufacturing excellence.',
  },
  {
    id: 'atul-churiwal',
    name: 'Atul Churiwal',
    role: 'Managing Director',
    organization: 'Krishi Rasayan Exports Pvt Ltd',
    imageSrc: 'https://iiabexpo.com/uploads/speakers/atul-churiwal-1782713289.jpg',
    category: 'industry_leader',
    bio: 'Steering high-volume active ingredient synthesis, technical manufacturing, and export corridors across 40+ countries.',
  },
  {
    id: 'bakulchandra-joshi',
    name: 'Bakulchandra Joshi',
    role: 'President & Chief Operating Officer',
    organization: 'T.Stanes & Company Ltd',
    imageSrc: 'https://iiabexpo.com/uploads/speakers/bakulchandra-joshi-1782713299.jpg',
    category: 'industry_leader',
    bio: 'Spearheading biological pest control, organic inputs, and specialized botanical extracts for high-yield farming.',
  },
];

export const allPatrons: PatronSpeaker[] = [...guestsOfHonor, ...industrySpeakers];

export default allPatrons;
